module.exports = __webpack_public_path__ + "static/img/28.8e0e3ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/28.jpg
// module id = L4/7
// module chunks = 1